import React from "react";

/** Placeholder rows while email/SMS template lists load */
export const TemplateListSkeleton: React.FC = () => (
  <div className="divide-y divide-gray-100 animate-pulse">
    {Array.from({ length: 6 }).map((_, i) => (
      <div key={i} className="px-4 lg:px-5 py-3 lg:py-3.5 flex items-center justify-between gap-3">
        <div className="min-w-0 flex-1 space-y-2">
          <div className="h-4 bg-gray-200 rounded w-2/5 max-w-[200px]" />
          <div className="h-3 bg-gray-100 rounded w-3/5 max-w-[280px]" />
        </div>
        <div className="h-3 bg-gray-100 rounded w-10 shrink-0" />
      </div>
    ))}
  </div>
);
